import { RegisterItem } from '../decorators/snitem-factory-decorator';
import { SNUser } from './snuser';
import { SNSex } from './snsex';
import * as moment from 'moment';
import { SmsService } from '../services/sms.service';

@RegisterItem()
export class CNUser extends SNUser {

    private cacheBirthday: Date;
    private cacheAge: number;

    constructor(itemid: number = 0) {
        super(itemid);
        this.key = 'SNItem.SNUser.CNUser';
    }

    get description(): string {
        return this.getProperty('Firstname') + ' ' + this.getProperty('Lastname');
    }

    get groupName(): string {
        if (this.getProperty('Type') === 'Group') {
            return this.getProperty('Lastname');
        }
        return '';
    }

    get birthday(): Date {
        if (!this.cacheBirthday) {
            this.cacheBirthday = moment(this.getProperty('Birthday'), 'DD/MM/YYYY').toDate();
        }
        return this.cacheBirthday;
    }

    get age(): number {
        if (!this.cacheAge) {
            this.cacheAge = Math.floor(moment.duration(moment().diff(moment(this.birthday))).asYears());
        }
        return this.cacheAge;
    }

    get sex(): SNSex {
        return new SNSex(this.getProperty('Sex'));
    }

    get smsNumber(): string {
        const smsService = SmsService.getInstance();
        let thenumber = this.getProperty('Mobile');
        if (!thenumber || thenumber === null) {
            return undefined;
        }
        if (smsService.isMobile(thenumber)) {
            return smsService.sanitize(thenumber);
        }
        thenumber = this.getProperty('Telephone');
        if (smsService.isMobile(thenumber)) {
            return smsService.sanitize(thenumber);
        }
        thenumber = this.getProperty('Telephone2');
        if (smsService.isMobile(thenumber)) {
            return smsService.sanitize(thenumber);
        }
        return undefined;
    }

    public clone(): any {
        return new CNUser();
    }
}
